import { FaChartLine, FaBookOpen, FaMoneyBill, FaClock, FaHandsHelping, FaArrowUp } from 'react-icons/fa';
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Team",
    heading: "Join the Woodwork & Carpenter Team Today",
    description:
        "At Woodwork & Carpenter, we're seeking committed individuals to join our team of experts. Explore rewarding career opportunities in woodworking and carpentry services. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
    points: [
        "Opportunities in Custom Woodwork",
        "Assist in Carpentry Operations",
        "Advanced Woodworking Training Programs",
        "Carpentry Situation Management",
        "Support in Woodwork Safety Measures",
    ],
    image: {
        src: images.careerIntro,
        alt: "Career-Image",
    },
};


const benefits = [
    {
        id: 1,
        icon: <FaChartLine />,
        title: "Career Advancement",
        description: "Explore opportunities for career growth and advancement within the woodworking and carpentry industry.",
    },
    {
        id: 2,
        icon: <FaBookOpen />,
        title: "Training Programs",
        description: "Participate in comprehensive training programs to enhance your skills and knowledge in woodworking and carpentry services.",
    },
    {
        id: 3,
        icon: <FaMoneyBill />,
        title: "Competitive Pay",
        description: "Enjoy competitive pay packages and benefits while working in the woodworking and carpentry industry.",
    },
    {
        id: 4,
        icon: <FaClock />,
        title: "Flexible Hours",
        description: "Benefit from flexible working hours that accommodate your schedule and lifestyle needs in the woodworking and carpentry industry.",
    },
    {
        id: 5,
        icon: <FaHandsHelping />,
        title: "Team Support",
        description: "Experience a supportive team environment where collaboration and teamwork are valued in the woodworking and carpentry industry.",
    },
    {
        id: 6,
        icon: <FaArrowUp />,
        title: "Growth Potential",
        description: "Unlock opportunities for personal and professional growth with ample room for advancement in the woodworking and carpentry industry.",
    },
];


const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Woodworker',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 2+ Years in Woodworking or Carpentry',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Craft custom wood pieces, repair wooden structures, and contribute to various carpentry projects. Woodworkers are expected to deliver precision craftsmanship, ensure material quality, and meet project deadlines.',
        ],
        responsibilities: [
            'Read and interpret blueprints, technical drawings, and design plans.',
            'Measure, cut, and shape wood materials accurately.',
            'Assemble wooden components using appropriate tools and techniques.',
            'Perform sanding, staining, and finishing work on wood surfaces.',
            'Inspect and repair damaged wood products and structures.',
            'Maintain a safe and clean workspace and adhere to safety regulations.',
        ],
        qualifications: [
            'High school diploma or equivalent; technical training is a plus.',
            '2+ years of experience in woodworking or carpentry.',
            'Proficiency with woodworking tools and machinery.',
            'Strong attention to detail and craftsmanship.',
            'Ability to work independently and as part of a team.',
            'Physical ability to lift heavy materials and stand for extended periods.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Carpenter',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 2+ Years in Carpentry',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Perform a wide range of carpentry tasks including framing, trim work, and finishing. Carpenters will collaborate with other trades, follow blueprints, and ensure quality craftsmanship on all construction and renovation projects.',
        ],
        responsibilities: [
            'Construct, install, and repair structures and fixtures made from wood and other materials.',
            'Interpret blueprints, drawings, and sketches to determine project requirements.',
            'Measure, cut, and shape wood, drywall, and other materials accurately.',
            'Install doors, windows, floors, cabinets, and other finish carpentry elements.',
            'Ensure work is completed to code and safety standards.',
            'Collaborate with supervisors and other construction professionals on site.',
        ],
        qualifications: [
            'High school diploma or equivalent; carpentry certification is a plus.',
            '2+ years of experience in general or finish carpentry.',
            'Familiarity with hand tools, power tools, and construction equipment.',
            'Strong understanding of construction methods and materials.',
            'Attention to detail and ability to follow technical drawings.',
            'Physical stamina and strength to perform demanding tasks.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Wood Finishing Specialist',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 2+ Years in Wood Finishing',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Responsible for sanding, staining, sealing, and applying finishes to wood products to ensure durability and aesthetic appeal. The Wood Finishing Specialist will work closely with production and quality teams to maintain high standards.',
        ],
        responsibilities: [
            'Prepare wooden surfaces by sanding and cleaning before finishing.',
            'Apply stains, varnishes, sealants, and other finishes evenly and efficiently.',
            'Inspect finished products to ensure quality and consistency.',
            'Maintain and clean finishing equipment and work areas.',
            'Follow safety guidelines for handling chemicals and materials.',
            'Collaborate with team members to meet production schedules and quality goals.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            '2+ years of experience in wood finishing or related field.',
            'Knowledge of various finishing materials and techniques.',
            'Attention to detail and a keen eye for color and texture.',
            'Ability to work independently and as part of a team.',
            'Strong focus on safety and quality standards.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Cabinet Maker',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 2+ Years in Cabinet Making',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Responsible for crafting high-quality custom cabinets from design through installation, ensuring precise measurements and finishes. The Cabinet Maker will collaborate with designers and clients to meet specifications.',
        ],
        responsibilities: [
            'Read and interpret blueprints and technical drawings.',
            'Cut, assemble, and install cabinets using various woodworking tools and machinery.',
            'Select appropriate materials and finishes for each project.',
            'Ensure accuracy and quality throughout the cabinet making process.',
            'Maintain a clean and safe work environment.',
            'Communicate with clients and team members to address project requirements.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            '2+ years of experience in cabinet making or woodworking.',
            'Proficiency with woodworking tools and machinery.',
            'Strong attention to detail and craftsmanship.',
            'Good communication and teamwork skills.',
            'Ability to work on multiple projects and meet deadlines.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Woodshop Assistant',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 1+ Year in Woodworking or Workshop Support',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Assist woodworkers and carpenters with daily tasks, including preparing materials, maintaining tools and equipment, and ensuring a safe and organized workshop environment.',
        ],
        responsibilities: [
            'Prepare and organize wood materials for projects.',
            'Maintain and clean woodworking tools and machinery.',
            'Assist in loading and unloading materials.',
            'Keep the workshop clean, safe, and well-organized.',
            'Support woodworkers during assembly and finishing stages.',
            'Follow safety protocols and guidelines.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Experience or interest in woodworking or workshop assistance.',
            'Ability to follow instructions and work in a team.',
            'Basic knowledge of woodworking tools is a plus.',
            'Strong work ethic and reliability.',
            'Willingness to learn and take on various tasks.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Woodworking Supervisor',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 3+ Years in Woodworking or Supervisory Role',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Manage daily woodworking shop activities, supervise staff, maintain quality standards, and ensure workplace safety.',
        ],
        responsibilities: [
            'Coordinate woodworking projects from start to finish.',
            'Supervise woodworkers and assistants.',
            'Monitor quality control and adherence to specifications.',
            'Ensure compliance with safety regulations.',
            'Manage scheduling and resource allocation.',
            'Provide training and support to team members.',
        ],
        qualifications: [
            'High school diploma or equivalent; technical training preferred.',
            'Proven experience in woodworking and team supervision.',
            'Strong leadership and organizational skills.',
            'Knowledge of woodworking tools, techniques, and safety standards.',
            'Excellent communication and problem-solving abilities.',
        ],
    }

];

export { positions, benefits, careerIntro };